import { useGetApiList, useMutateGetApi } from '@/apiError/apiShow';
import { AntButton } from '@/common/ant-components/AntButton';
import { AntSwitch } from '@/common/ant-components/AntSwitch';
import DraggableModal from '@/common/ant-components/DraggableModal';
import LedgerForm from '@/components/forms/master/account/ledger/LedgerForm';
import { validateNonNegative } from '@/components/forms/transaction/purchase/helpers';
import { useTransactionContext } from '@/context/TransactionContext';
import useAppData from '@/hooks/useAppData';
import CalculatorAppWithModal from '@/layouts/componets/calculator-app-with-modal';
import {
  beforeUpload,
  customRequest,
  imageOnChange,
  normFile,
  onPreview,
  onRemove,
  tagProcessedFile,
} from '@/pages/admin/master/company/form/common';
import { roundTo3 } from '@/pages/transaction/purchase/helpers';
import { thirdFormBoxCalculation } from '@/utils/formula/CodeWindow';
import LoadingOverlay from '@/utils/loading/loadingOverlay';
import GlobalFormModal from '@/utils/modal/GlobalFormModal';
import CustomSelect from '@/utils/search/Search';
import { showToast } from '@/utils/toastMessage/ToastMessage';
import {
  handlePaste,
  OnlyIntegerUptoThreeDigit,
  OnlyIntegerUptoThreeDigitT,
  OnlyIntegerUptoThreeDigitWithoutDecimal,
  validateGramAndLalDecimalDigits,
  validateGramAndLalDecimalDigitsOnChange,
  validateGramAndLalDecimalDigitsT,
  valueLimiterPercentage,
  valueLimiterPurity,
  weightValidation,
  weightValidationT,
} from '@/utils/validation/FormValidation';
import { DeleteOutlined, UploadOutlined } from '@ant-design/icons';
import {
  Button,
  Card,
  Checkbox,
  Col,
  ConfigProvider,
  Form,
  Image,
  Input,
  InputNumber,
  message,
  Row,
  Select,
  Upload,
} from 'antd';
import { useImageCrop } from '@/components/reusable/modal/imageCropModal';
import Cookies from 'js-cookie';
import { debounce } from 'lodash';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

const DynamicCodeWIndowForm = ({
  loading,
  firstInputRef,
  formData,
  onFieldChange,
  onPurityChange,
  isDefault,
  isReturnCodeWindow,
  form,
  setFormData,
  primaryCalculationType,
  fileList,
  from,
  itemName,
  itemCode,
  onHandleSalesDescription,
}) => {
  const {
    salesToPurchase,
    setIsModalVisible,
    setOpen,
    setIsCancel,
    setCalculatorOpen,
    setTargetId,
    targetId,
    salesSelectedData,
  } = useTransactionContext();

  const { app } = useAppData();

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const location = useLocation();
  const returnTrue = location.pathname.includes('return');
  const salesReturnTrue = location.pathname.includes('/sales/return/');

  const salesTrue = location.pathname.includes('/transaction/sales/');

  const salesOrderTrue = location.pathname.includes(
    '/transaction/sales/order/',
  );

  const imagesList = formData?.images;

  const isSalesImagesShow =
    location.pathname.includes('/sales/create/') ||
    location.pathname.includes('/sales/edit/');

  const isSalesQuotation =
    location.pathname.includes('/sales/quotation/create/') ||
    location.pathname.includes('/transaction/sales/quotation/edit/');

  const showMrpField =
    location.pathname.includes('/transaction/stock/edit') ||
    location.pathname.includes('/opening/stock/create/') ||
    location.pathname.includes('/codewindow/') ||
    location.pathname.includes('/transaction/purchase/edit');

  const showFixedAmount = [
    '/codewindow/',
    '/transaction/purchase/edit/',
    '/purchase/return/code/window/',
    '/opening/stock/create/',
    '/transaction/sales/create/',
    '/transaction/sales/edit/',
  ]?.some((path) => location.pathname.includes(path));

  const [isKarigarModalVisible, setIsKarigarModalVisible] = useState(false);
  const {
    data: karigarData,
    isPending,
    refetch,
  } = useGetApiList('/account/karigar/ledgers/');

  const showImage = Cookies.get('showImage') === 'true';

  const isSalesEdit = location.pathname.includes('sales/edit');

  const disableReferenceCode = ['sales/create', 'sales/edit'].some((route) =>
    location.pathname.includes(route),
  );
  const karigarDropDown = ['/transaction/stock/', 'opening/stock'];
  const openingStockKarigarDropDown = karigarDropDown?.some((path) =>
    location.pathname.includes(path),
  );

  const { mutateAsync: getMutate, isPending: exchangeLoading } =
    useMutateGetApi();

  const isEnableExchange = Form.useWatch('isExchange', form);

  const trayNameRemark = [
    '/transaction/stock/',
    '/transaction/purchase/',
    '/sales/return/code/window/',
    '/codewindow/',
    '/codewindow-modal/',
    'opening/stock',
  ].some((route) => location.pathname.includes(route));

  const disableGrossWt = [
    '/sales/return/code/window/',
    '/purchase/return/code/window/',
  ].some((route) => location.pathname.includes(route));

  const inputRef = useRef(null);
  const selectRef = useRef(null);

  const uploadRef = useRef(null);

  const { cropImage, cropModal } = useImageCrop();

  const formD = Form.useFormInstance();

  const focusNode = (key) => {
    const inputInstance = formD?.getFieldInstance(key);
    if (inputInstance) {
      inputInstance?.focus();
    }
  };

  const handleAddClick = () => {
    setIsKarigarModalVisible(true);
  };

  useEffect(() => {
    if (inputRef?.current) {
      setTimeout(() => {
        inputRef?.current?.focus(
          {
            cursor: 'end',
          },
          100,
        );
      });
    }
  }, []);

  const handleKeyDown = (e) => {
    if (e) {
      setTargetId(e?.target?.id);
    }
    if (e?.altKey && e.code === 'KeyC') {
      e.preventDefault();
      setCalculatorOpen && setCalculatorOpen(true);
    }
    if (e?.code === 'F10') {
      e.preventDefault();
      form
        .validateFields()
        .then(() => {
          setIsCancel('not-cancel');
          formD.submit();
        })
        .catch((errorInfo) => {
          const firstErrorField = errorInfo.errorFields[0]?.name?.[0];
          if (firstErrorField) {
            formD.getFieldInstance(firstErrorField)?.focus();
          }
        });
    }
    if (e.code === 'F3') {
      e.preventDefault();
      setIsModalVisible(true);
    }
    if (e.code === 'F5') {
      e.preventDefault();
      setOpen(true);
    }
  };

  const { pathname } = useLocation();

  const routeToAllowNegative = [
    '/codewindow',
    '/transaction/purchase/edit',
    '/transaction/receive/karigar/create',
    '/transaction/receive/karigar/edit/',
    '/sales/return/code/window/',
    '/transaction/receive/refine/create',
    '/transaction/receive/refine/edit',
    '/transaction/receive/party/create',
    '/transaction/receive/party/edit',
    '/transaction/stock/create/',
    '/transaction/stock/edit/',
  ];

  const isRouteToAllowNegative = routeToAllowNegative.some((route) =>
    pathname?.includes(route),
  );

  const fetchPartyList = async () => {
    refetch();
  };

  const handleDebouncedChange = useCallback(
    debounce(async (value) => {
      const response = await getMutate({
        url: `transactions/order-item/prefix-search/?itemPrefix=${value}&ledgerId=${salesSelectedData?.ledger}`,
      });

      if (response?.data?.code === '1') {
        showToast(response?.data?.message, 'error');
        form.resetFields(['exchangeCode']);
        form.setFieldsValue({
          orderDetailId: null,
        });
        form.setFields([
          {
            name: 'exchangeCode',
            errors: [response?.data?.message || 'Invalid exchange code'],
          },
        ]);
      }

      if (response?.data?.code === '0') {
        onFieldChange('exchangeCode', response?.data?.exchangeCode || value);
        form.setFieldsValue({
          orderDetailId: response?.data?.orderDetailId,
        });
        showToast(response?.data?.message, 'success');
        form.setFields([
          {
            name: 'exchangeCode',
            errors: [],
          },
        ]);
      }
    }, 500), // debounce delay in ms
    [salesSelectedData?.ledger], // dependencies
  );

  const handleChange = (e) => {
    const value = e.target.value;
    handleDebouncedChange(value);
  };

  function getNextName(name, existing) {
    const dotIndex = name.lastIndexOf('.');
    const base = dotIndex === -1 ? name : name.slice(0, dotIndex);
    const ext = dotIndex === -1 ? '' : name.slice(dotIndex);

    const regex = /-(\d+)$/;
    const match = base.match(regex);

    let counter = 1;
    let rawBase = base;

    if (match) {
      rawBase = base.replace(regex, '');
      counter = parseInt(match[1], 10) + 1;
    }

    let newName = `${rawBase}-${counter}${ext}`;

    while (existing.includes(newName)) {
      counter++;
      newName = `${rawBase}-${counter}${ext}`;
    }

    return newName;
  }

  return (
    <div style={{ display: 'flex' }}>
      <div>
        <LoadingOverlay loading={loading} />
        <Row gutter={[24, 24]}>
          <Col span={5}>
            <Form.Item
              className="username"
              label="Set/Pcs"
              name="setPcs"
              rules={[
                {
                  required: true,
                  message: '',
                },
              ]}
            >
              <InputNumber
                style={{
                  width: '100%',
                }}
                min={0}
                max={100}
                type="number"
                controls={false}
                onPressEnter={(e) => {
                  e.preventDefault();
                  focusNode('referenceItemCode');
                }}
                maxLength={3}
                parser={(value) => value?.replace(/[^0-9.]/g, '')}
                onChange={(value) => onFieldChange('setPcs', value)}
                onKeyDown={OnlyIntegerUptoThreeDigitWithoutDecimal}
                // ref={firstInputRef}
                disabled={returnTrue}
              />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item
              className="username"
              label="Reference Code"
              name="referenceItemCode"
            >
              <Input
                value={formData?.referenceItemCode}
                style={{ width: '100%' }}
                onPressEnter={(e) => {
                  e.preventDefault();
                  focusNode('rate');
                }}
                autoComplete="off"
                onKeyUp={(e) => {
                  if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    focusNode('setPcs');
                  } else {
                    handleKeyDown(e);
                  }
                }}
                onChange={(e) =>
                  onFieldChange('referenceItemCode', e.target.value)
                }
                disabled={returnTrue}
              />
            </Form.Item>
          </Col>

          <Col span={5}>
            <Form.Item
              className="username"
              label="Rate (24K)"
              name="rate"
              initialValue={0}
              rules={[
                {
                  required:
                    (salesReturnTrue || salesTrue) && !salesOrderTrue
                      ? false
                      : true,
                  message: '',
                },
                // ...((salesReturnTrue || salesTrue) && !salesOrderTrue
                //   ? []
                //   : [
                {
                  validator: (_, value) =>
                    value == 0
                      ? Promise.reject('Rate cannot be 0')
                      : Promise.resolve(),
                },
                // ]),
              ]}
            >
              <Input
                value={formData?.rate}
                style={{ width: '100%' }}
                // min={0}
                // type="number"
                step={0}
                onPressEnter={(e) => {
                  e.preventDefault();
                  focusNode('free_rate');
                }}
                onKeyUp={(e) => {
                  e.preventDefault();
                  if (e.code === 'ArrowUp') {
                    focusNode('referenceItemCode');
                    return;
                  } else {
                    handleKeyDown(e);
                  }
                }}
                // parser={(value) => value?.replace(/[^0-9.]/g, '')}
                onBlur={(e) => {
                  const value = e?.target?.value;
                  if (value === '' || value === undefined || value === null) {
                    form.setFieldsValue({ rate: 0 });
                    return;
                  } else {
                    const numericRate = roundTo3(value);
                    form.setFieldsValue({
                      rate: Number(numericRate || 0),
                    });
                  }
                }}
                controls={false}
                onKeyDown={OnlyIntegerUptoThreeDigit}
                onChange={(e) => {
                  const raw = e.target.value;
                  const sanitizedValue = raw.replace(/^(-?)0+(\d)/, '$1$2');
                  onFieldChange('rate', sanitizedValue || 0);
                }}
                // disabled={returnTrue}
              />
            </Form.Item>
          </Col>

          <Col span={5}>
            <Form.Item
              shouldUpdate={(prevValues, curValues) =>
                prevValues.rate !== curValues.rate ||
                prevValues.purity !== curValues.purity
              }
              noStyle
            >
              {({ getFieldsValue }) => {
                const { purity, rate } = getFieldsValue();

                const free_rate =
                  ((Number(purity) || 0) / 100) * (Number(rate) || 0);

                // const roundedFreeRate = parseFloat(free_rate?.toFixed(3));
                // const roundedFreeRate = Number(free_rate?.toFixed(3) ?? 0);
                // const roundedFreeRate = parseFloat(free_rate || 0)?.toFixed(3);
                const roundedFreeRate = Number(roundTo3(free_rate || 0));

                if (form.getFieldValue('free_rate') !== roundedFreeRate) {
                  form.setFieldsValue({ free_rate: roundedFreeRate });
                }

                return (
                  <Form.Item className="username" label="Rate" name="free_rate">
                    <InputNumber
                      style={{ width: '100%' }}
                      min={0}
                      type="number"
                      step={0}
                      controls={false}
                      formatter={(value) => String(Number(value))}
                      onPressEnter={(e) => {
                        e.preventDefault();
                        focusNode('grossWeight');
                      }}
                      onKeyUp={(e) => {
                        e.preventDefault();
                        if (e.key === 'ArrowUp') {
                          focusNode('rate');
                        } else {
                          handleKeyDown(e);
                        }
                      }}
                      onChange={(value) => {
                        const validValue = value ?? 0;
                        const validPurity = purity ?? 1;

                        const rate =
                          validPurity !== 0
                            ? (validValue * 100) / validPurity
                            : 0;
                        const roundedRate = roundTo3(rate || 0);

                        form.setFieldsValue({
                          rate: Number(roundedRate),
                        });
                        setFormData({
                          ...formData,
                          ...form.getFieldValue(),
                          rate: Number(roundedRate),
                        });
                      }}
                      disabled={returnTrue}
                      onKeyDown={OnlyIntegerUptoThreeDigit}
                    />
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={5}>
            <Form.Item
              className="username"
              label={`Gross wts (${primaryCalculationType})`}
              name="grossWeight"
              rules={[
                {
                  required: true,
                  message: '',
                },
                {
                  validator: (field, value) =>
                    validateGramAndLalDecimalDigits(
                      field,
                      form,
                      primaryCalculationType === 'gm' ? 'gm' : 'lal',
                      value,
                    ),
                },
                {
                  validator: validateNonNegative,
                },
              ]}
            >
              <Input
                style={{ width: '100%' }}
                controls={false}
                ref={inputRef}
                autoComplete="off"
                onChange={(e) => {
                  const { isValid, inputValue } =
                    validateGramAndLalDecimalDigitsOnChange(
                      'grossWeight',
                      e.target?.value,
                    );
                  if (isValid) {
                    onFieldChange('grossWeight', inputValue);
                  }
                }}
                onPressEnter={async (e) => {
                  e?.preventDefault();
                  try {
                    await form.validateFields(['grossWeight']);
                    focusNode('grossWeightGm');
                  } catch (error) {
                    focusNode('grossWeight');
                  }
                }}
                onKeyDown={(e) => {
                  handleKeyDown(e);
                  OnlyIntegerUptoThreeDigit(e);
                }}
                onKeyUp={(e) => {
                  if (e?.key === 'ArrowUp') {
                    e.preventDefault();
                    focusNode('free_rate');
                  }
                }}
                onPaste={(e) => handlePaste(e, 'grossWeight', onFieldChange)}
                disabled={disableGrossWt}
              />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item
              className="username"
              label={`Gross wts (${primaryCalculationType === 'lal' ? 'gm' : 'lal'})`}
              name="grossWeightGm"
              rules={[
                {
                  required: false,
                  message: '',
                },
                {
                  validator: (field, value) =>
                    validateGramAndLalDecimalDigits(
                      field,
                      form,
                      primaryCalculationType === 'gm' ? 'lal' : 'gm',
                      value,
                    ),
                },
                {
                  validator: (_, value) =>
                    value >= 0
                      ? Promise.resolve()
                      : Promise.reject(new Error('Negative Value')),
                },
              ]}
            >
              <Input
                style={{ width: '100%' }}
                controls={false}
                autoComplete="off"
                onChange={(e) => {
                  const { isValid, inputValue } =
                    validateGramAndLalDecimalDigitsOnChange(
                      'grossWeightGm',
                      e.target?.value,
                    );
                  if (isValid) {
                    onFieldChange('grossWeightGm', inputValue);
                  }
                }}
                onKeyDown={(e) => {
                  handleKeyDown(e);
                  OnlyIntegerUptoThreeDigit(e);
                }}
                onKeyUp={(e) => {
                  if (e?.key === 'ArrowUp') {
                    e.preventDefault();
                    focusNode('grossWeight');
                  }
                }}
                onPressEnter={(e) => {
                  e.preventDefault();
                  focusNode('crt');
                }}
                onPaste={(e) => handlePaste(e, 'grossWeightGm', onFieldChange)}
                disabled={disableGrossWt}
              />
            </Form.Item>
          </Col>

          <Col span={5}>
            <Form.Item
              className="username"
              label="Purity"
              name="crt"
              rules={[
                {
                  required: true,
                  message: '',
                },
              ]}
            >
              <InputNumber
                addonBefore="crt"
                controls={false}
                max={24}
                onPressEnter={(e) => {
                  e.preventDefault(e);
                  focusNode('purity');
                }}
                onKeyDown={(e) => {
                  handleKeyDown(e);
                  valueLimiterPurity(e, 24);
                }}
                onKeyUp={(e) => {
                  if (e?.key === 'ArrowUp') {
                    e.preventDefault();
                    focusNode('grossWeightGm');
                  }
                }}
                onChange={(value) => onPurityChange('crt', value)}
                value={isDefault ? 24 : formData?.crt}
                disabled={isDefault || isReturnCodeWindow}
              />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item
              className="username"
              label={<span>&nbsp;</span>} // This keeps space in label
              name="purity"
              rules={[
                {
                  validator: (_, value) => {
                    if (value === undefined || value === null || value === '') {
                      return Promise.reject('Purity is required');
                    }
                    const numericValue = parseFloat(value);
                    if (isNaN(numericValue)) {
                      return Promise.reject('Purity must be a number');
                    }
                    if (numericValue < 0 || numericValue > 100) {
                      return Promise.reject('Purity must be between 0 and 100');
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input
                addonBefore="%"
                // type="text"
                step={0}
                onPressEnter={(e) => {
                  e.preventDefault(e);
                  focusNode('makingChargeType');
                }}
                onKeyDown={(e) => {
                  handleKeyDown(e);
                  valueLimiterPercentage(e, 100);
                }}
                onKeyUp={(e) => {
                  if (e?.key === 'ArrowUp') {
                    e.preventDefault();
                    focusNode('crt');
                  }
                }}
                onChange={(e) => onPurityChange('purity', e.target.value)}
                value={isDefault ? 100 : formData?.purity}
                disabled={isDefault || isReturnCodeWindow}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={7}>
            <Form.Item
              className="username"
              label="Making Charge"
              name="makingChargeType"
              // rules={[
              //   {
              //     required: true,
              //     message: '',
              //   },
              // ]}
            >
              <Select
                value={formData.makingChargeType}
                showSearch
                options={[
                  {
                    value: 'amount',
                    label: 'Amount',
                  },
                  {
                    value: 'percentage',
                    label: 'Percentage',
                  },
                  {
                    value: 'rate',
                    label: 'Rate',
                  },
                ]}
                onChange={(value) => {
                  onFieldChange('makingChargeType', value);
                  setFormData({
                    ...formData,
                    ...form.getFieldsValue(),
                    makingCharge: 0,
                    makingAmount: 0,
                  });
                  form.setFieldsValue({
                    ...formData,
                    ...form.getFieldsValue(),
                    makingCharge: 0,
                    makingAmount: 0,
                  });
                }}
                onSelect={(e) => {
                  if (e === 'amount') {
                    focusNode('makingAmount');
                  }
                  if (e === 'percentage' || e === 'rate') {
                    focusNode('makingCharge');
                  }
                }}
                onKeyDown={(e) => {
                  if (e.shiftKey && e.code === 'ArrowLeft') {
                    e.preventDefault();
                    focusNode('purity');
                  }
                  if (
                    e.shiftKey &&
                    (e.code === 'Enter' || e.code === 'NumpadEnter') &&
                    form.getFieldValue('makingChargeType') === 'amount'
                  ) {
                    focusNode('makingAmount');
                  }
                  if (
                    e.shiftKey &&
                    (e.code === 'Enter' || e.code === 'NumpadEnter') &&
                    form.getFieldValue('makingChargeType') === 'percentage'
                  ) {
                    focusNode('makingCharge');
                  }
                  if (
                    e.shiftKey &&
                    (e.code === 'Enter' || e.code === 'NumpadEnter') &&
                    form.getFieldValue('makingChargeType') === 'rate'
                  ) {
                    focusNode('makingCharge');
                  }
                }}
              />
            </Form.Item>
          </Col>

          <Col span={7}>
            <Form.Item
              className="username"
              label="Charge"
              name="makingCharge"
              rules={[
                {
                  required: false,
                  message: '',
                },
              ]}
            >
              <Input
                style={{ width: '100%' }}
                controls={false}
                onPressEnter={(e) => {
                  if (e.code === 'Enter' || e.code === 'NumpadEnter') {
                    e.preventDefault();
                    focusNode('wastageType');
                  }
                }}
                onKeyUp={(e) => {
                  e.preventDefault();
                  if (e.code === 'ArrowUp') {
                    focusNode('makingChargeType');
                  }
                }}
                step={0}
                onChange={(e) => onFieldChange('makingCharge', e.target.value)}
                disabled={form.getFieldValue('makingChargeType') === 'amount'}
                onKeyDown={(e) => {
                  if (form.getFieldValue('makingChargeType') === 'percentage') {
                    valueLimiterPercentage(e, 100);
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              className="username"
              label="Amount"
              name="makingAmount"
              rules={[
                {
                  required: false,
                  message: '',
                },
              ]}
            >
              <Input
                controls={false}
                // type="number"
                style={{ width: '100%' }}
                value={formData.makingAmount}
                step={0}
                disabled={
                  form.getFieldValue('makingChargeType') === 'percentage' ||
                  form.getFieldValue('makingChargeType') === 'rate'
                }
                onChange={(e) => {
                  const raw = e.target.value;
                  const sanitizedValue = raw.replace(/^(-?)0+(\d)/, '$1$2');
                  onFieldChange('makingAmount', sanitizedValue || 0);
                }}
                onKeyDown={(e) => {
                  handleKeyDown(e);
                  OnlyIntegerUptoThreeDigit(e);
                }}
                onPressEnter={(e) => {
                  e?.preventDefault();
                  focusNode('wastageType');
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={7}>
            <Form.Item
              className="username"
              label="Wastage Type"
              name="wastageType"
            >
              <Select
                showSearch
                onChange={(value) => {
                  onFieldChange('wastageType', value);
                  setFormData({
                    ...formData,
                    ...form.getFieldsValue(),
                    wastageCharge: 0,
                    wastageWeight: 0,
                  });
                  form.setFieldsValue({
                    ...formData,
                    ...form.getFieldsValue(),
                    wastageCharge: 0,
                    wastageWeight: 0,
                  });
                }}
                onSelect={(value) => {
                  if (value === 'w') {
                    focusNode('wastageWeight');
                  } else {
                    focusNode('wastageCharge');
                  }
                }}
                onKeyUp={(e) => {
                  e.preventDefault();
                  if (e.shiftKey && e.code === 'ArrowLeft') {
                    focusNode('makingAmount');
                  }
                }}
                value={formData?.wastageType}
              >
                <Select.Option value="w">W</Select.Option>
                <Select.Option value="gw">Gw</Select.Option>
                <Select.Option value="nw">Nw</Select.Option>
                <Select.Option value="pw">Pw</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={7}>
            <Form.Item
              className="username"
              label="Charge"
              name="wastageCharge"
              rules={
                isRouteToAllowNegative
                  ? [
                      {
                        validator: (_, value) => {
                          if (
                            value === undefined ||
                            value === null ||
                            value === ''
                          ) {
                            return Promise.resolve();
                          }
                          const numValue = Number(value);
                          if (
                            isNaN(numValue) ||
                            numValue < -100 ||
                            numValue > 100
                          ) {
                            return Promise.reject(
                              new Error('Value must be between -100 and 100'),
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]
                  : []
              }
            >
              <Input
                style={{ width: '100%' }}
                controls={false}
                onPressEnter={(e) => {
                  e?.preventDefault();
                  focusNode('extraAmount');
                }}
                maxLength={4}
                step={0}
                onChange={(e) => {
                  onFieldChange('wastageCharge', e?.target?.value);
                  thirdFormBoxCalculation(form, formData, setFormData);
                }}
                disabled={form.getFieldValue('wastageType') === 'w'}
                onKeyDown={(e) => {
                  if (!isRouteToAllowNegative) {
                    valueLimiterPercentage(e, 100);
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              className="username"
              // initialValue={0}
              rules={[
                {
                  validator: (field, value) =>
                    isRouteToAllowNegative
                      ? validateGramAndLalDecimalDigitsT(
                          field,
                          form,
                          primaryCalculationType === 'gm' ? 'gm' : 'lal',
                          value,
                        )
                      : validateGramAndLalDecimalDigitsT(
                          field,
                          form,
                          primaryCalculationType === 'gm' ? 'gm' : 'lal',
                          value,
                        ),
                },
              ]}
              label={
                <div className="tw-flex tw-items-center tw-justify-center tw-gap-2">
                  Weight
                  {app?.calculateOnPure && !salesOrderTrue && (
                    <Form.Item noStyle name="isPure" valuePropName="checked">
                      <Checkbox default={true} />
                    </Form.Item>
                  )}
                </div>
              }
              name="wastageWeight"
            >
              <Input
                // type='number'
                controls={false}
                style={{ width: '100%' }}
                onChange={(e) => {
                  const { isValid, inputValue } = isRouteToAllowNegative
                    ? weightValidationT(e?.target?.value)
                    : weightValidation(e?.target?.value);
                  if (isValid) {
                    onFieldChange('wastageWeight', inputValue);
                  }
                }}
                onPaste={(e) => handlePaste(e, 'wastageWeight', onFieldChange)}
                onPressEnter={(e) => {
                  e?.preventDefault();
                  focusNode('extraAmount');
                }}
                onBlur={(e) => {
                  const value = e?.target?.value;
                  if (value === '' || value === undefined || value === null) {
                    form.setFieldsValue({ wastageWeight: 0 });
                  }
                }}
                disabled={form.getFieldValue('wastageType') != 'w'}
                onKeyDown={(e) => {
                  isRouteToAllowNegative
                    ? OnlyIntegerUptoThreeDigitT(e)
                    : OnlyIntegerUptoThreeDigit(e);
                  handleKeyDown(e);
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={disableReferenceCode ? 5 : 7}>
            <Form.Item
              className="username"
              label="Extra amount"
              name="extraAmount"
              rules={[
                {
                  required: false,
                  message: '',
                },
              ]}
            >
              <Input
                controls={false}
                style={{ width: '100%' }}
                onPressEnter={(e) => {
                  e?.preventDefault();
                  focusNode('size');
                }}
                onKeyDown={(e) => {
                  OnlyIntegerUptoThreeDigit(e);
                  handleKeyDown(e);
                }}
                onChange={(e) => {
                  const raw = e.target.value;
                  const sanitizedValue = raw.replace(/^(-?)0+(\d)/, '$1$2');
                  onFieldChange('extraAmount', sanitizedValue || 0);
                }}
              />
            </Form.Item>
          </Col>

          <Col span={disableReferenceCode ? 5 : 7}>
            <Form.Item className="username" label="Size" name="size">
              <Input
                onChange={(e) => onFieldChange('size', e.target.value)}
                maxLength={20}
                type="text"
                onPressEnter={(e) => {
                  e?.preventDefault();
                  focusNode('description');
                }}
                onKeyDown={(e) => {
                  handleKeyDown(e);
                }}
              />
            </Form.Item>
          </Col>

          <Col span={disableReferenceCode ? 5 : 6}>
            <Form.Item
              className="username"
              label="Description"
              name="description"
            >
              <Input
                onChange={(e) => onFieldChange('description', e.target.value)}
                maxLength={20}
                onPressEnter={(e) => {
                  e?.preventDefault();
                  focusNode(
                    disableReferenceCode
                      ? 'roundOff'
                      : trayNameRemark
                        ? 'remarks'
                        : 'fixedAmount',
                  );
                }}
                type="text"
              />
            </Form.Item>
          </Col>
          {disableReferenceCode && (
            <Col span={5}>
              <Form.Item className="username" label="RoundOff" name="roundOff">
                <InputNumber
                  style={{ width: '100%' }}
                  onChange={(value) => onFieldChange('roundOff', value)}
                  controls={false}
                  onPressEnter={(e) => {
                    e?.preventDefault();
                    focusNode(trayNameRemark ? 'remarks' : 'fixedAmount');
                  }}
                  type="number"
                />
              </Form.Item>
            </Col>
          )}
        </Row>
        {trayNameRemark && (
          <Row gutter={24}>
            {trayNameRemark && (
              <Col span={7}>
                <Form.Item
                  className="username"
                  label="Remarks"
                  name="remarks"
                  rules={[
                    {
                      validator: (_, value) => {
                        if (value?.length > 20) {
                          return Promise.reject('Maximum length should be 20');
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    onChange={(e) => onFieldChange('remarks', e.target.value)}
                    maxLength={20}
                    onPressEnter={(e) => {
                      e?.preventDefault();
                      focusNode('trayName');
                    }}
                    type="text"
                  />
                </Form.Item>
              </Col>
            )}
            <Col span={7}>
              <Form.Item
                className="username"
                label="Tray Name"
                name="trayName"
                rules={[
                  {
                    validator: (_, value) => {
                      if (value?.length > 20) {
                        return Promise.reject('Maximum length should be 20');
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  onChange={(e) => onFieldChange('trayName', e.target.value)}
                  onPressEnter={(e) => {
                    e?.preventDefault();
                    focusNode(
                      openingStockKarigarDropDown
                        ? selectRef.current.focus()
                        : 'fixedAmount',
                    );
                  }}
                  type="text"
                />
              </Form.Item>
            </Col>
            {openingStockKarigarDropDown && (
              <Col span={6}>
                <Form.Item
                  className="username"
                  label="Karigar"
                  name="karigarId"
                  initialValue={null}
                >
                  <CustomSelect
                    loading={isPending}
                    selectRef={selectRef}
                    onSelect={() => {
                      focusNode('fixedAmount');
                    }}
                    onKeyDown={(e) => {
                      if (
                        e.key === '+' ||
                        e.code === 'Equal' ||
                        e.code === 'NumpadAdd'
                      ) {
                        e.preventDefault();
                        handleAddClick();
                      }
                    }}
                    onAddClick={handleAddClick}
                    onChange={(value) => onFieldChange('karigarId', value)}
                    options={karigarData?.data?.map((partyName) => ({
                      value: partyName.referenceId,
                      label: partyName.name,
                    }))}
                  />
                </Form.Item>
              </Col>
            )}
          </Row>
        )}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', width: '50%' }}>
        <div>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item
                className="username"
                label="Diamond pcs"
                name="diamondPcs"
              >
                <Input type="text" value={formData.diamondPcs} disabled />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                className="username"
                label={`Weight ${primaryCalculationType} `}
                name="diamondWeightGram"
              >
                <Input
                  onChange={(e) =>
                    onFieldChange('diamondWeightGram', e.target.value)
                  }
                  disabled
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                className="username"
                label="Weight crt"
                name="diamondWeightCrt"
              >
                <Input
                  type="text"
                  onChange={(e) =>
                    onFieldChange('diamondWeightCrt', e.target.value)
                  }
                  disabled
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                className="username"
                label="Amount"
                name="diamondAmount"
              >
                <Input
                  onChange={(e) =>
                    onFieldChange('diamondAmount', e.target.value)
                  }
                  disabled
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item className="username" label="Stone pcs" name="stonePcs">
                <Input type="text" disabled />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                className="username"
                label={`Weight ${primaryCalculationType}`}
                name="stoneWeightGram"
              >
                <Input
                  onChange={(e) =>
                    onFieldChange('stoneWeightGram', e.target.value)
                  }
                  disabled
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                className="username"
                label="Weight crt"
                name="stoneWeightCrt"
              >
                <Input
                  type="text"
                  onChange={(e) =>
                    onFieldChange('stoneWeightCrt', e.target.value)
                  }
                  disabled
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item className="username" label="Amount" name="stoneAmount">
                <Input
                  onChange={(e) => onFieldChange('stoneAmount', e.target.value)}
                  disabled
                />
              </Form.Item>
            </Col>
          </Row>
        </div>

        {/* <hr style={{ marginBottom: '16px' }} /> */}
        <div>
          <Row gutter={24}>
            <>
              {' '}
              <Col span={6}>
                <Form.Item
                  className="username"
                  label={`Net wt (${primaryCalculationType})`}
                  name="netWeight"
                  rules={[
                    {
                      validator: validateNonNegative,
                    },
                  ]}
                >
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  className="username"
                  label={`Net wt (${primaryCalculationType === 'lal' ? 'gm' : 'lal'})`}
                  name="netWeightGm"
                  rules={[
                    {
                      validator: validateNonNegative,
                    },
                  ]}
                >
                  <Input
                    disabled
                    onChange={(e) => onFieldChange('netWeight', e.target.value)}
                  />
                </Form.Item>
              </Col>
            </>

            <Col span={6}>
              <Form.Item
                className="username"
                label="Net with wastage"
                name="netWithWastage"
                rules={[
                  {
                    validator: validateNonNegative,
                  },
                ]}
              >
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                className="username"
                label="Pure wt"
                name="pureWeight"
                rules={[
                  {
                    validator: validateNonNegative,
                  },
                ]}
              >
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                className="username"
                label="Fixed Amount"
                name="fixedAmount"
              >
                <Select
                  showSearch
                  onChange={(value) => onFieldChange('fixedAmount', value)}
                  onSelect={(e) => {
                    if (e === 'yes') {
                      focusNode('netAmount');
                    }
                  }}
                  onKeyUp={(e) => {
                    e.preventDefault();
                    if (e.shiftKey && e.code === 'ArrowLeft') {
                      focusNode('description');
                    }
                  }}
                  onKeyDown={handleKeyDown}
                  disabled={showFixedAmount ? true : false}
                >
                  <Select.Option value="yes">Yes</Select.Option>
                  <Select.Option value="no">No</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                className="username"
                label="Metal amount"
                name="metalAmount"
              >
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                className="username"
                label="Net Amount"
                name="netAmount"
                rules={[
                  {
                    validator: validateNonNegative,
                  },
                ]}
              >
                <Input
                  type="text"
                  value={formData.netAmount}
                  onChange={(e) => onFieldChange('netAmount', e.target.value)}
                  disabled={formData.fixedAmount === 'no'}
                  onKeyDown={(e) => {
                    OnlyIntegerUptoThreeDigit(e);
                    handleKeyDown(e);
                  }}
                />
              </Form.Item>
            </Col>
            {/* 
            <Col span={8} hidden={!disableReferenceCode}>
              
            </Col> */}

            {/* <Col
              span={9}
              style={{
                display: !disableReferenceCode ? 'none' : 'flex',
                gap: '5px',
              }}
            >
              <AntSwitch
                formProps={{
                  name: 'isExchange',
                  initialValue: formData?.isExchange || false,
                  label: 'Exchange?',
                }}
                onChange={(value) => {
                  onFieldChange('isExchange', value);
                  if (value) {
                    if (!salesSelectedData?.ledger) {
                      message.info(
                        'Please select a ledger before entering the exchange code.',
                      );
                    }
                    form.setFields([
                      {
                        name: 'exchangeCode',
                        errors: ['Enter exchange code'],
                      },
                    ]);
                  } else {
                    form.resetFields(['exchangeCode']);
                    form.setFields([
                      {
                        name: 'exchangeCode',
                        errors: [],
                      },
                    ]);
                  }
                }}
              />
              <Form.Item
                className="username"
                label="Exchange with Order Item"
                name="exchangeCode"
                rules={[
                  {
                    required: isEnableExchange ? true : false,
                    message: 'Please enter valid order code',
                  },
                ]}
              >
                <Input
                  type="text"
                  disabled={!isEnableExchange || !salesSelectedData?.ledger}
                  value={formData.exchangeCode}
                  onInput={(e) => {
                    e.target.value = e.target.value.toUpperCase();
                  }}
                  onChange={handleChange}
                  onKeyDown={(e) => {
                    handleKeyDown(e);
                  }}
                />
              </Form.Item>
            </Col> */}

            <Col
              xs={24}
              sm={12}
              md={8}
              style={{
                display: showMrpField ? 'block' : 'none',
              }}
            >
              <Form.Item
                className="username"
                label="MRP"
                name="sNetAmount"
                // rules={[
                //   {
                //     validator: (_, value) => {
                //       if (value === 0) {
                //         return Promise.reject('Net amount cannot be 0.');
                //       }
                //       return Promise.resolve();
                //     },
                //   },
                // ]}
              >
                <Input
                  type="text"
                  disabled={showFixedAmount ? true : false}
                  onChange={(e) => {
                    onHandleSalesDescription &&
                      onHandleSalesDescription('sNetAmount', e.target.value);
                  }}
                />
              </Form.Item>
            </Col>

            <Col
              span={8}
              style={{
                display:
                  isSalesImagesShow && formData?.images?.length > 0
                    ? 'block'
                    : 'none',
              }}
            >
              <div className="tw-flex-col">
                <div className="tw-font-semibold tw-mb-[6px]">Image List</div>
                <div className="tw-grid tw-grid-cols-3">
                  {imagesList?.map((image, index) => (
                    <Image
                      key={index}
                      width={70}
                      // height={70}
                      src={image?.image}
                      alt={image || `Item image-${index}`}
                    />
                  ))}
                </div>
              </div>
            </Col>

            <Col span={4}>
              {showImage &&
              !returnTrue &&
              !salesToPurchase &&
              !isSalesQuotation &&
              from !== 'sales' ? (
                <ConfigProvider
                  theme={{
                    components: {
                      Upload: {
                        controlHeight: 24,
                        controlHeightLG: 24,
                      },
                    },
                  }}
                >
                  <Row>
                    <Form.Item
                      className="username text-start"
                      label="Item Image"
                      name="image"
                      valuePropName="file"
                      getValueFromEvent={normFile}
                      // hidden={!app?.showImage || false}
                    >
                      <Upload
                        ref={uploadRef}
                        multiple
                        maxCount={app?.imageMaxCount}
                        showUploadList={{
                          removeIcon: (
                            <DeleteOutlined
                              style={{ color: 'red', fontSize: 14 }}
                            />
                          ),
                        }}
                        accept=".jpg, .jpeg, .png, .gif"
                        fileList={
                          formData?.fileList
                            ? formData?.fileList
                            : fileList || []
                        }
                        listType="picture-card"
                        openFileDialogOnClick={true}
                        onChange={(info) => {
                          imageOnChange(info, formData, setFormData);
                        }}
                        onPreview={(file) =>
                          onPreview(file, setPreviewImage, setPreviewOpen)
                        }
                        beforeUpload={async (file) => {
                          if (
                            formData?.fileList?.length >= app?.imageMaxCount
                          ) {
                            message.error(
                              `You can only upload ${app?.imageMaxCount} ${app?.imageMaxCount === 1 ? 'image.' : 'images.'}`,
                            );
                            return Upload.LIST_IGNORE;
                          }

                          if (!String(itemCode ?? '').trim()) {
                            message.error(
                              'Please wait for the item code before uploading an image.',
                            );
                            return Upload.LIST_IGNORE;
                          }

                          if (
                            !['image/jpeg', 'image/jpg', 'image/png'].includes(
                              file.type,
                            )
                          ) {
                            message.error(
                              'Only JPG, JPEG, and PNG files are allowed!',
                            );
                            return Upload.LIST_IGNORE;
                          }

                          const croppedFile = await cropImage(file);
                          if (!croppedFile) return Upload.LIST_IGNORE;

                          const baseFile = await beforeUpload(
                            croppedFile,
                            itemName,
                            itemCode,
                          );

                          if (!baseFile) return Upload.LIST_IGNORE;

                          const extension = (
                            baseFile.name.split('.').pop() || 'jpg'
                          ).toLowerCase();
                          const safeItemName = String(itemName || 'image')
                            .trim()
                            .replace(/\s+/g, '_');
                          const baseName = itemCode
                            ? `${safeItemName}_${itemCode}`
                            : safeItemName;

                          const names =
                            formData?.fileList?.map((x) => x.name) ?? [];
                          const newName = getNextName(
                            `${baseName}.${extension}`,
                            names,
                          );

                          const finalFile = new File([baseFile], newName, {
                            type: baseFile.type,
                          });
                          finalFile.uid = file.uid;
                          return tagProcessedFile(file, finalFile);
                        }}
                        customRequest={customRequest}
                      >
                        <UploadOutlined /> Upload
                      </Upload>
                    </Form.Item>
                    {previewImage && (
                      <Image
                        wrapperStyle={{ display: 'none' }}
                        preview={{
                          visible: previewOpen,
                          onVisibleChange: (visible) => setPreviewOpen(visible),
                          afterOpenChange: (visible) =>
                            !visible && setPreviewImage(''),
                        }}
                        src={previewImage}
                      />
                    )}
                  </Row>
                </ConfigProvider>
              ) : (
                ''
              )}
            </Col>
          </Row>
        </div>
      </div>
      {cropModal}
      <GlobalFormModal
        title="Create Ledger"
        isVisible={isKarigarModalVisible}
        onClose={() => {
          setIsKarigarModalVisible(false);
        }}
      >
        <LedgerForm
          onClose={() => {
            setIsKarigarModalVisible(false);
          }}
          refreshTable={fetchPartyList}
        />
      </GlobalFormModal>

      <CalculatorAppWithModal
        form={form}
        formData={formData}
        targetId={targetId}
        setFormData={setFormData}
        onFieldChange={onFieldChange}
      />
    </div>
  );
};

export default DynamicCodeWIndowForm;
